'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _styles = require('../../common/styles');

exports.default = {
	container: {
		background: 'rgba(0, 0, 0, 0.8)',
		color: _styles.colors.baseColors.offWhite,
		fontSize: '14px',
		padding: '4px'
	}
};


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMToolTip/styles/index.js